/*!
 * caravan24 Embed 1.2.0 - https://caravan24.ch/
 * (c) 2022 ayon GmbH
 */

import loader from "./loader";

loader('caravan24')